export default __webpack_public_path__ + "static/scheduler_example-574ee3a49af168f7751e4d7e76bd3055.png";